import { render } from "./DailyImplantsCare.vue?vue&type=template&id=4f87f053"
import script from "./DailyImplantsCare.vue?vue&type=script&lang=js"
export * from "./DailyImplantsCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__